<div class="pnl-settings-personalization">
  <header>
    <a [routerLink]="['/app/configuracao/design']" class="back">Design</a>
    <h1>Personalização</h1>
  </header>

  <form [formGroup]="websiteFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div class="f2 mr10">
        <strong>Cores do layout</strong>
        <span
          >Ao escolher as cores para a loja online, procure manter a mesma
          identidade visual da sua marca e das cores utilizadas na loja
          física</span
        >

        <ul>
          <li>
            <span>Fundo do site</span>
            <input
              (colorPickerChange)="onChangeDetail()"
              [style.background]="color_background"
              [cpAlphaChannel]="'disabled'"
              [cpOutputFormat]="'hex'"
              [(colorPicker)]="color_background"
            />
          </li>

          <li>
            <span>Fundo do cabeçalho</span>
            <input
              (colorPickerChange)="onChangeDetail()"
              [style.background]="color_background_header"
              [cpAlphaChannel]="'disabled'"
              [cpOutputFormat]="'hex'"
              [(colorPicker)]="color_background_header"
            />
          </li>

          <li>
            <span>Principal</span>
            <input
              (colorPickerChange)="onChangeDetail()"
              [style.background]="color_primary"
              [cpAlphaChannel]="'disabled'"
              [cpOutputFormat]="'hex'"
              [(colorPicker)]="color_primary"
            />
          </li>

          <li>
            <span>Complementar</span>
            <input
              (colorPickerChange)="onChangeDetail()"
              [style.background]="color_secondary"
              [cpAlphaChannel]="'disabled'"
              [cpOutputFormat]="'hex'"
              [(colorPicker)]="color_secondary"
            />
          </li>

          <li>
            <span>Botão “comprar”</span>
            <input
              (colorPickerChange)="onChangeDetail()"
              [style.background]="color_btn_buy"
              [cpAlphaChannel]="'disabled'"
              [cpOutputFormat]="'hex'"
              [(colorPicker)]="color_btn_buy"
            />
          </li>

          <li>
            <span>Botão “carrinho”</span>
            <input
              (colorPickerChange)="onChangeDetail()"
              [style.background]="color_btn_cart"
              [cpAlphaChannel]="'disabled'"
              [cpOutputFormat]="'hex'"
              [(colorPicker)]="color_btn_cart"
            />
          </li>

          <li>
            <span>Tag de oferta</span>
            <input
              (colorPickerChange)="onChangeDetail()"
              [style.background]="color_offer_tag"
              [cpAlphaChannel]="'disabled'"
              [cpOutputFormat]="'hex'"
              [(colorPicker)]="color_offer_tag"
            />
          </li>

          <li>
            <span>Formato da tag de oferta</span>
            <ng-select
              [items]="offer_tag_format_list"
              (change)="onChangeDetail()"
              (clear)="onChangeDetail()"
              formControlName="offer_tag_format"
              placeholder="Selecione"
              [searchable]="false"
              [clearable]="false"
            ></ng-select>
          </li>
        </ul>
      </div>

      <div class="f1 ml10">
        <strong>Logotipo</strong>
        <span>Use a marca do seu supermercado na loja online</span>

        <div
          ng2FileDrop
          [uploader]="uploader"
          (fileOver)="fileOverBase($event)"
          [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
          class="drag-zone-upload"
        >
          <div
            *ngIf="
              (uploader.queue && uploader.queue.length > 0) || imageLogo != ''
            "
            class="image-cover"
          >
            <img [src]="imageLogo" *ngIf="imageLogo != ''" />
            <img
              *ngFor="let item of uploader.queue; let i = index"
              src=""
              imgPreview
              [image]="item?._file"
            />
          </div>

          <div
            *ngIf="
              uploader.queue && uploader.queue.length == 0 && imageLogo == ''
            "
            class="image-cover"
          >
            <fa-icon [icon]="faImage"></fa-icon>

            <h6>Adicione o logo do estabelecimento</h6>
          </div>

          <input
            id="fileUploader"
            #fileUploader
            type="file"
            ng2FileSelect
            [uploader]="uploader"
            class="dnone"
          />

          <div class="image-cover">
            <button
              (click)="fileUploader.click()"
              type="button"
              class="btn btn-primary"
            >
              Adicionar logo
            </button>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="f2 mr10">
        <strong>Fontes</strong>

        <div class="form-col">
          <label>Font-family principal</label>
          <!-- <ng-select
            [items]="font_list"
            formControlName="font_primary"
            (change)="onChangeDetail()"
            (clear)="onChangeDetail()"
            placeholder="Selecione"
            [searchable]="false"
            [clearable]="false"
          ></ng-select> -->
          <input
            type="text"
            formControlName="font_primary"
            class="form-control"
            (keyup)="onChangeDetail()"
          />
        </div>

        <div class="form-col">
          <label>Font-family secundária</label>
          <!-- <ng-select
            [items]="font_list"
            formControlName="font_secondary"
            (change)="onChangeDetail()"
            (clear)="onChangeDetail()"
            placeholder="Selecione"
            [searchable]="false"
            [clearable]="false"
          ></ng-select> -->
          <input
            type="text"
            formControlName="font_secondary"
            class="form-control"
            (keyup)="onChangeDetail()"
          />
        </div>
        <div class="form-col">
          <label>Font-family botões</label>
          <!-- <ng-select
            [items]="font_list"
            formControlName="font_btn"
            (change)="onChangeDetail()"
            (clear)="onChangeDetail()"
            placeholder="Selecione"
            [searchable]="false"
            [clearable]="false"
          ></ng-select> -->
          <input
            type="text"
            formControlName="font_btn"
            class="form-control"
            (keyup)="onChangeDetail()"
          />
        </div>
        <div class="form-col">
          <label>Font link</label>
          <input
            type="text"
            formControlName="font_link"
            class="form-control"
            (keyup)="onChangeDetail()"
          />
        </div>
      </div>

      <div class="f1 ml10">
        <strong>Favicon</strong>
        <span>Use um pequeno ícone que identifica a sua loja online no navegador web</span>

        <div
          ng2FileDrop
          [uploader]="uploaderFavicon"
          (fileOver)="fileOverBaseFavicon($event)"
          [ngClass]="{ 'nv-file-over': hasBaseDropZoneOverFavicon }"
          class="drag-zone-upload"
        >
          <div
            *ngIf="
              (uploaderFavicon.queue && uploaderFavicon.queue.length > 0) || imageFavicon != ''
            "
            class="image-cover"
          >
            <img [src]="imageFavicon" *ngIf="imageFavicon != ''" />
            <img
              *ngFor="let item of uploaderFavicon.queue; let i = index"
              src=""
              imgPreview
              [image]="item?._file"
            />
          </div>

          <div
            *ngIf="
              uploaderFavicon.queue && uploaderFavicon.queue.length == 0 && imageFavicon == ''
            "
            class="image-cover"
          >
            <fa-icon [icon]="faImage"></fa-icon>

            <h6>Adicione o favicon do estabelecimento</h6>
          </div>

          <input
            id="fileUploaderFavicon"
            #fileUploaderFavicon
            type="file"
            ng2FileSelect
            [uploader]="uploaderFavicon"
            class="dnone"
          />

          <div class="image-cover">
            <button
              (click)="fileUploaderFavicon.click()"
              type="button"
              class="btn btn-primary"
            >
              Adicionar favicon
            </button>
          </div>
        </div>
      </div>
    </section>
  </form>

  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button
        type="button"
        (click)="onCancel()"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">
        Salvar
      </button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
